import React from 'react';
import { BOOK_DEMO_URL, Cta, GET_STARTED_URL, IMG } from './shared';

const AUDIENCES = [
  {
    eyebrow: 'Leisure',
    title: 'More direct rentals.',
    copy: 'Attract locals and travelers looking for the perfect car for road trips, events, and getaways.',
    image: `${IMG}/renter/leisure-customers.png`,
    alt: 'Friends loading luggage into a rental SUV for a weekend trip',
  },
  {
    eyebrow: 'Rideshare',
    title: 'Keep drivers earning.',
    copy: 'Serve rideshare drivers who need reliable, gig-approved vehicles by the week for steady passenger trips.',
    image: `${IMG}/renter/gig-rideshare.png`,
    alt: 'A rideshare driver at the wheel with a passenger seated in the rear',
  },
  {
    eyebrow: 'Food delivery',
    title: 'Power every drop-off.',
    copy: 'Give food couriers dependable wheels for peak-hour orders — recurring weekly rentals your fleet can count on.',
    image: `${IMG}/renter/gig-food.png`,
    alt: 'A food delivery courier handing a paper food bag to a customer at a doorstep',
  },
  {
    eyebrow: 'Package delivery',
    title: 'Move more packages.',
    copy: 'Equip last-mile package drivers with cargo-ready vehicles for doorstep deliveries, day in and day out.',
    image: `${IMG}/renter/gig-package.png`,
    alt: 'A delivery driver carrying cardboard packages from a white van to a house door',
  },
];

/** Same hover choreography as the roadside cards, at a shorter height. */
const AudienceCard = ({ audience, tall }) => (
  <div className={`ilp-offer ilp-card${tall ? ' ilp-offer--tall' : ''}`}>
    <img src={audience.image} alt={audience.alt} className="ilp-offer-img" />

    <span aria-hidden="true" className="ilp-offer-glyph">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline className="ilp-offer-glyph-tr" points="14 4 20 4 20 10" />
        <polyline className="ilp-offer-glyph-bl" points="10 20 4 20 4 14" />
      </svg>
    </span>

    <div className="ilp-offer-label">
      <span className="ilp-offer-dot" aria-hidden="true" />
      <p>{audience.eyebrow}</p>
    </div>

    <div className="ilp-offer-detail">
      <div className="ilp-offer-detail-head">
        <span className="ilp-offer-dot" aria-hidden="true" />
        <p>{audience.eyebrow}</p>
      </div>
      <h3>{audience.title}</h3>
      <p className="ilp-offer-copy">{audience.copy}</p>
    </div>
  </div>
);

/** "More customers, more revenue" — one hero card plus a row of three. */
const AttractAudiences = () => {
  const [hero, ...rest] = AUDIENCES;

  return (
    <section className="ilp-audiences">
      <div className="ilp-audiences-top">
        <div className="ilp-audiences-copy">
          <p className="ilp-eyebrow">More customers, more revenue</p>
          <h2 className="ilp-audiences-title">Attract all types of renters, from one platform.</h2>
          <p className="ilp-audiences-sub">
            Capture more revenue from every vehicle in your fleet—serving everyone from weekend travelers
            to gig drivers.
          </p>
          <div className="ilp-cta-row ilp-audiences-ctas">
            <Cta href={GET_STARTED_URL} label="Get Started" />
            <Cta href={BOOK_DEMO_URL} label="Book Demo" tone="dark" />
          </div>
        </div>

        <AudienceCard audience={hero} tall />
      </div>

      <div className="ilp-audiences-grid">
        {rest.map((a) => (
          <AudienceCard key={a.eyebrow} audience={a} />
        ))}
      </div>
    </section>
  );
};

export default AttractAudiences;
